import { render } from "./Payment.vue?vue&type=template&id=d0cefb64&scoped=true"
import script from "./Payment.vue?vue&type=script&lang=js"
export * from "./Payment.vue?vue&type=script&lang=js"

import "./Payment.vue?vue&type=style&index=0&id=d0cefb64&lang=less&scoped=true"
import "./Payment.vue?vue&type=style&index=1&id=d0cefb64&lang=less"

import exportComponent from "/data/web/pay/idpay/idpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0cefb64"]])

export default __exports__